import { render } from "./OnlineComplete.vue?vue&type=template&id=78c5c53b&scoped=true&ts=true"
import script from "./OnlineComplete.vue?vue&type=script&lang=ts"
export * from "./OnlineComplete.vue?vue&type=script&lang=ts"

import "./OnlineComplete.vue?vue&type=style&index=0&id=78c5c53b&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78c5c53b"]])

export default __exports__